module.exports = __webpack_public_path__ + "static/media/ProximaNova-Semibold.a2eed25f.woff";